import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { M2A } from 'www-cms';
import { AmpersandAndTextComponent } from '../../../building-blocks/ampersand-and-text/ampersand-and-text.component';
import { CarouselComponent } from '../../../building-blocks/carousel/carousel.component';
import { FaqsComponent } from '../../../building-blocks/faqs/faqs.component';
import { FloatingTilesComponent } from '../../../building-blocks/floating-tiles/floating-tiles.component';
import { HeroMediaComponent } from '../../../building-blocks/hero-image/hero-media.component';
import { ImageTilesComponent } from '../../../building-blocks/image-tiles/image-tiles.component';
import { InfoModalComponent } from '../../../building-blocks/info-modal/info-modal.component';
import { JotformBlockComponent } from '../../../building-blocks/jotform-block/jotform-block.component';
import { JumpToSectionComponent } from '../../../building-blocks/jump-to-section/jump-to-section.component';
import { LargeItemCardsComponent } from '../../../building-blocks/large-item-cards/large-item-cards.component';
import { NowPlayingComponent } from '../../../building-blocks/now-playing/now-playing.component';
import { PromoBlockComponent } from '../../../building-blocks/promo-block/promo-block.component';
import { PromoModalComponent } from '../../../building-blocks/promo-modal/promo-modal.component';
import { SideBySideImageTextComponent } from '../../../building-blocks/sideBySideImageText/side-by-side-image-text.component';
import { StarDividerComponent } from '../../../building-blocks/star-divider/star-divider.component';
import { TextBlockComponent } from '../../../building-blocks/text-block/text-block.component';
import { TextCTAComponent } from '../../../building-blocks/text-cta/text-cta.component';
import { SmallCardsComponent } from '../../../building-blocks/small-card/small-card.component';
import { SideBySideCarouselTextComponent } from '../../../building-blocks/side-by-side-carousel-text/side-by-side-carousel-text.component';
import { TextByTextCardComponent } from '../../../building-blocks/text-by-text-card/text-by-text-card.component';
import { InfoCarouselComponent } from '../../../building-blocks/info-carousel/info-carousel.component';
import { DonationFormComponent } from '../../../building-blocks/donation-form/donation-form.component';
import { SideBySideCarouselDynamicTextComponent } from '../../../building-blocks/side-by-side-carousel-dynamic-text/side-by-side-carousel-dynamic-text.component';

/**
 * Tried to make this shared with the page component, but it caused a circular dep.
 */
@Component({
  selector: 'ss-www-building-block-outlet',
  imports: [
    AmpersandAndTextComponent,
    CarouselComponent,
    FaqsComponent,
    FloatingTilesComponent,
    HeroMediaComponent,
    InfoModalComponent,
    LargeItemCardsComponent,
    PromoBlockComponent,
    PromoModalComponent,
    StarDividerComponent,
    JotformBlockComponent,
    JumpToSectionComponent,
    ImageTilesComponent,
    TextCTAComponent,
    SideBySideImageTextComponent,
    TextBlockComponent,
    NowPlayingComponent,
    SmallCardsComponent,
    SideBySideCarouselTextComponent,
    TextByTextCardComponent,
    InfoCarouselComponent,
    DonationFormComponent,
    SideBySideCarouselDynamicTextComponent,
  ],
  templateUrl: './building-block-outlet.component.html',
  styleUrls: ['./building-block-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildingBlockOutletComponent {
  @Input() blocks!: M2A<any>[];
  @Input() setLastItemFooterBackground = true;

  trackBlock(index: number, block: M2A<any>) {
    return block.id;
  }
}
